import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DATA_COLLECTION_ROUTE_ID_KEY, DATA_COLLECTION_ROUTE_KEY, MAIN_PAGE } from './constants/constants';
import { DataCollectionComponent } from './data-collection.component';
import { DataCollectionResolver } from './resolvers/data-collection.resolver';

const healthSafetyRoutes: Routes = [
    {
        path: '',
        component: DataCollectionComponent,
        children: [
            {
                path: '',
                redirectTo: MAIN_PAGE,
                pathMatch: 'full',
            },
            {
                path: `inspection/:${DATA_COLLECTION_ROUTE_ID_KEY}`,
                // canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./pages/data-collection/data-collection.module').then((m) => m.DataCollectionPageModule),
                resolve: { [DATA_COLLECTION_ROUTE_KEY]: DataCollectionResolver },
            },
            {
                path: `inspections/:${DATA_COLLECTION_ROUTE_ID_KEY}`,
                // canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./pages/data-collection/data-collection.module').then((m) => m.DataCollectionPageModule),
                resolve: { [DATA_COLLECTION_ROUTE_KEY]: DataCollectionResolver },
            },
            {
                path: `surveys/:${DATA_COLLECTION_ROUTE_ID_KEY}`,
                // canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./pages/data-collection/data-collection.module').then((m) => m.DataCollectionPageModule),
                resolve: { [DATA_COLLECTION_ROUTE_KEY]: DataCollectionResolver },
            },
            {
                path: `forms/:${DATA_COLLECTION_ROUTE_ID_KEY}`,
                // canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./pages/data-collection/data-collection.module').then((m) => m.DataCollectionPageModule),
                resolve: { [DATA_COLLECTION_ROUTE_KEY]: DataCollectionResolver },
            },
            {
                path: 'inspections',
                // canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./pages/data-collections/data-collections.module').then((m) => m.DataCollectionsPageModule),
            },
            {
                path: 'surveys',
                loadChildren: () =>
                    import('./pages/surveys/surveys.module').then((m) => m.SurveysModule),
            },
            {
                path: 'forms',
                loadChildren: () =>
                    import('./pages/common-forms/common-forms.module').then((m) => m.CommonFormsModule),
            },
            {
                path: '**',
                loadChildren: () =>
                    import('./pages/not-found/not-found.module').then((m) => m.NotFoundModule),
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(healthSafetyRoutes)],
    exports: [RouterModule],
    providers: [
        DataCollectionResolver,
    ],
})
export class DataCollectionRoutingModule { }
